import ErrorView from '@components/ErrorView';
import './index.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ConnectionsRedirectPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const provider = searchParams.get("provider");
  const success = searchParams.get("success") == "true";

  let providerName = '';
  switch (provider) {
    case 'pco':
      providerName = 'Planning Center';
      break;
    default:
      providerName = 'provider';
      break;
  }

  if (!success) {
    return <ErrorView error={`Failed to connect with ${providerName}.`}
      buttonText='Continue'
      buttonAction={() => navigate('/connections')} />
  }

  return <div className="redirect-success-view">
    <h1>✅</h1>
    <h1>Successfully Connected!</h1>
    <p>You've successfully connected with {providerName}.</p>

    <a href="#" onClick={() => navigate('/connections')}>Continue</a>
  </div>
}